function createOrgChart(data, containerId) {
  // Ordenar nodos hijos alfabéticamente
  function sortChildrenByLabelOrder(data) {
    if (data.children) {
      // Filtrar y ordenar solo los nodos normales (no espaciadores)
      const normalNodes = data.children.filter(child => !child.isSpacer);

      // Ordenar alfabéticamente usando localeCompare para mejor handling de caracteres especiales
      normalNodes.sort((a, b) => {
        const labelA = (a.label || '').toString().toLowerCase().trim();
        const labelB = (b.label || '').toString().toLowerCase().trim();
        return labelA.localeCompare(labelB);
      });

      // Reemplazar solo con nodos normales ordenados (sin espaciadores)
      data.children = normalNodes;

      // Aplicar ordenamiento recursivamente a todos los hijos
      data.children.forEach(child => sortChildrenByLabelOrder(child));
    }
  }

  sortChildrenByLabelOrder(data);

  const container = d3.select(`#${containerId}`);
  const width = container.node().getBoundingClientRect().width;
  const height = container.node().getBoundingClientRect().height;

  const marginTop = 10, marginRight = 10, marginBottom = 10, marginLeft = 100;
  const fontSize = 16;
  const dy = (width - marginRight - marginLeft) / 3;

  const root = d3.hierarchy(data);

  const tree = d3.tree()
    .nodeSize([1, dy])
    .separation((a, b) => {
      return a.parent === b.parent ? 0.5 : 2;
    });

  const verticalScale = 40;

  const svg = container.append("svg")
    .attr("width", width)
    .attr("height", height)
    .attr("viewBox", [-marginLeft, -marginTop, width, height])
    .attr("style", `max-width: 100%; height: auto; font: ${fontSize}px sans-serif; user-select: none;`);

  const gLink = svg.append("g")
    .attr("fill", "none")
    .attr("stroke", "#555")
    .attr("stroke-opacity", 0.4)
    .attr("stroke-width", 1.5);

  const gNode = svg.append("g")
    .attr("cursor", "pointer")
    .attr("pointer-events", "all");

  function update(event, source) {
    const duration = event?.altKey ? 2500 : 250;

    tree(root);
    const nodes = root.descendants();
    const links = root.links();

    nodes.forEach(d => {
      d.x *= verticalScale;
    });

    let left = root;
    let right = root;
    root.eachBefore(node => {
      if (node.x < left.x) left = node;
      if (node.x > right.x) right = node;
    });

    const height = right.x - left.x + marginTop + marginBottom;

    const transition = svg.transition()
      .duration(duration)
      .attr("height", height)
      .attr("viewBox", [-marginLeft, left.x - marginTop, width, height]);

    const diagonal = d3.linkHorizontal().x(d => d.y).y(d => d.x);

    const node = gNode.selectAll("g").data(nodes, d => d.id);

    const nodeEnter = node.enter().append("g")
      .attr("transform", d => `translate(${source?.y0 || 0},${source?.x0 || 0})`)
      .attr("fill-opacity", 0)
      .attr("stroke-opacity", 0)
      .on("click", (event, d) => {
        d.children = d.children ? null : d._children;
        update(event, d);
      });

    nodeEnter.append("circle")
      .attr("r", 4)
      .attr("fill", d => d._children ? "#555" : "#999");

    nodeEnter.append("text")
      .attr("dy", "0.31em")
      .attr("x", d => d._children ? -8 : 8)
      .attr("text-anchor", d => d._children ? "end" : "start")
      .text(d => d.data.label)
      .attr("font-size", fontSize)
      .clone(true).lower()
      .attr("stroke", "white");

    node.merge(nodeEnter).transition(transition)
      .attr("transform", d => `translate(${d.y},${d.x})`)
      .attr("fill-opacity", 1)
      .attr("stroke-opacity", 1);

    node.exit().transition(transition).remove()
      .attr("transform", d => `translate(${source?.y || 0},${source?.x || 0})`)
      .attr("fill-opacity", 0)
      .attr("stroke-opacity", 0);

    const link = gLink.selectAll("path").data(links, d => d.target.id);

    const linkEnter = link.enter().append("path")
      .attr("d", d => {
        const o = { x: source?.x0 || 0, y: source?.y0 || 0 };
        return diagonal({ source: o, target: o });
      });

    link.merge(linkEnter).transition(transition)
      .attr("d", diagonal);

    link.exit().transition(transition).remove()
      .attr("d", d => {
        const o = { x: source?.x || 0, y: source?.y || 0 };
        return diagonal({ source: o, target: o });
      });

    root.eachBefore(d => {
      d.x0 = d.x;
      d.y0 = d.y;
    });
  }

  root.x0 = dy / 2;
  root.y0 = 0;
  root.descendants().forEach((d, i) => {
    d.id = i;
    d._children = d.children;
  });

  update(null, root);

  window.addEventListener("resize", () => {
    const newWidth = container.node().getBoundingClientRect().width;
    const newHeight = container.node().getBoundingClientRect().height;
    svg.attr("width", newWidth).attr("height", newHeight);
  });
}